export default __webpack_public_path__ + "static/media/avatar.13d02500.png";